export enum YearChoices {
  full,
  Q1,
  Q2,
  Q3,
  Q4,
}
